ixModuleRouting("impactx.supplierbasket", {
    "/supplierbasket/:id?/:userId?/:comId?": {
        templateUrl: "modules/supplierbasket/templates/supplierbasket.html",
        controller: "SupplierBasketCtrl",
        controllerAs: "supplierBasketCtrl",
        process: "SupplierBasketTemplateEdit",
        workspace: "shop",
    },
    "/supplierbasket/:id?/:userId?/:comId?/:activate?": {
        templateUrl: "modules/supplierbasket/templates/supplierbasket.html",
        controller: "SupplierBasketCtrl",
        controllerAs: "supplierBasketCtrl",
        process: "SupplierBasketTemplateEdit",
        workspace: "shop",
    },
});
